var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "left-side-bar" },
    _vm._l(_vm.bars, function(item, key) {
      return _c("div", { key: key, staticClass: "block" }, [
        _c("span", { staticClass: "div_title" }, [_vm._v(_vm._s(item))])
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }